const SITUATIONS = [
  {
    title: "Vacance ou départ brutal du DSI",
    desc: "Départ soudain, intérim long, vacance de poste critique. Je prends le relais sans temps mort, je tiens la barre et je sécurise la continuité du SI.",
  },
  {
    title: "Crise IT majeure",
    desc: "Incident d'exploitation, attaque cyber, perte de confiance interne. Je structure la cellule de crise, coordonne la réponse et sécurise la sortie de crise.",
  },
  {
    title: "Transformation SI bloquée ou à risque",
    desc: "Programme ERP enlisé, migration cloud à la dérive, modernisation qui s'essouffle. Je reprends le pilotage, réaligne la trajectoire et remets le programme sous contrôle.",
  },
];

export default function Situations() {
  return (
    <section
      id="interventions"
      data-testid="situations-section"
      className="py-24 sm:py-36 px-6 sm:px-10 lg:px-16 bg-[#FAF8F5]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="reveal max-w-3xl mb-20">
          <p className="eyebrow flex items-center mb-6">
            <span className="gold-line" />
            Quand m'appeler
          </p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-[#0B132B] leading-[1.1]">
            Les situations dans lesquelles{" "}
            <span className="italic">j'interviens.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-[#E2DCD0]">
          {SITUATIONS.map((s, i) => (
            <div
              key={s.title}
              data-testid={`situation-card-${i}`}
              className="reveal group bg-[#FAF8F5] p-10 sm:p-12 transition-colors duration-500 hover:bg-[#F0ECE1]"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <p className="font-serif italic text-[#C8A97E] text-2xl mb-6">
                0{i + 1}
              </p>
              <h3 className="font-serif text-2xl text-[#0B132B] mb-4 leading-tight">
                {s.title}
              </h3>
              <p className="text-[#4A5568] leading-relaxed font-light">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
